import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

const sellerService = {
  getAll: () => apiClient.get(ENDPOINTS.SELLERS.GET_ALL),
  getById: (id) => apiClient.get(ENDPOINTS.SELLERS.GET_BY_ID(id)),
  create: (data) => apiClient.post(ENDPOINTS.SELLERS.CREATE, data),
  update: (id, data) => apiClient.put(ENDPOINTS.SELLERS.UPDATE(id), data),
  delete: (id) => apiClient.delete(ENDPOINTS.SELLERS.DELETE(id)),
  updateStatus: (id, status) => apiClient.put(ENDPOINTS.SELLERS.UPDATE_STATUS(id), { status }),
  assignUserToSeller: (userId, sellerId) =>
    apiClient.post(ENDPOINTS.SELLERS.ASSIGN_USERS(sellerId), [{ userId, role: 6 }]),
  assignUsersToSeller: (sellerId, userPayloads) =>
    apiClient.post(ENDPOINTS.SELLERS.ASSIGN_USERS(sellerId), userPayloads),
  getAssignedUsers: (sellerId) =>
    apiClient.get(ENDPOINTS.SELLERS.ASSIGNED_USERS(sellerId)),
  removeUsersFromSeller: (sellerId, userIds) =>
    apiClient.delete(ENDPOINTS.SELLERS.REMOVE_USERS(sellerId), { data: userIds }),
  getAccountManagerStats: () =>
    apiClient.get(ENDPOINTS.SELLERS.ACCOUNT_MANAGER_STATS),
  getNotificationCoverage: () =>
    apiClient.get(ENDPOINTS.SELLERS.NOTIFICATION_COVERAGE),
  exportSellers: () =>
    apiClient.get(ENDPOINTS.SELLERS.EXPORT, { responseType: 'blob' }),
};

export { sellerService };
